import React from "react";
import './SectionHeader.css';

import addButton from "../../../../../assets/images/addButton.svg";

const SectionHeader = (props) => {
    const {imageSrc = null, title = null, className = null, actionButton = false } = props
    return (
        <>
            {
                (title)
                ? <div className={ `header-wrapper ${className}`} >
                    <div className="header-title">
                        {imageSrc && <img src={imageSrc} alt="section-header-icon"/>}
                        <span >{title}</span>
                    </div>
                    { actionButton && <div className="add-button"> Add <img src={addButton} alt="+" /> </div> }
                </div>
                : null
            }
        </>
    )
}

export default SectionHeader;